import API from '../../constants/api';
import { isObjectValidAndNotEmpty } from '../../constants/nullCheckUtils';

export const JOURNAL_DATE_FILTERS = {
    TODAY: 'Today',
    YESTERDAY: 'Yesterday',
    LAST_7_DAYS: 'Past 7 Days',
    LAST_10_DAYS: 'Past 10 Days',
    LAST_30_DAYS: 'Past 30 Days',
    LAST_60_DAYS: 'Past 60 Days',
    LAST_90_DAYS: 'Past 90 Days',
    LAST_180_DAYS: 'Past 180 Days',
};

export const journalEntryStates = [
    { key: 'draft', value: 'DRAFT' },
    { key: 'posted', value: 'POSTED' },
];

export const getJournalEntryFilterSchema = (openingJournal, hideTransactionType = false) => {
    let filters = [];
    if (!isObjectValidAndNotEmpty(openingJournal)) {
        filters.push({
            name: 'journal',
            label: 'Journal',
            type: 'autocomplete',
            defaultValue: '',
            dataSourceApi: API.SEARCH.ACCOUNT_JOURNAL,
            dataSourceConfig: {
                text: 'name',
                value: 'id',
            },
        });
    }
    if (!hideTransactionType) {
        filters.push({
            name: 'transactionType',
            label: 'Transaction Type',
            type: 'autocomplete',
            defaultValue: '',
            dataSourceApi: '/nuacare-core//rest/nuacare/v1/master/defaultJournal/types?searchString=',
            dataSourceConfig: {
                text: 'value',
                value: 'key',
            },
        });
    }
    filters = [
        ...filters,
        {
            name: 'memo',
            label: 'Memo',
            type: 'fieldWithOperation',
            options: ['contains'],
            valueType: 'text',
            valueLabel: 'Search With',
        },
        {
            name: 'journalEntryState',
            type: 'select',
            label: 'State',
            disableClear: false,
            valueField: 'key',
            options: journalEntryStates,
        },
        {
            name: 'datePeriod',
            type: 'dateRange',
            label: 'Period',
            valueField: 'key',
            disableClear: true,
            showOnTop: true,
            options: Object.keys(JOURNAL_DATE_FILTERS).map(aPeriod => ({
                key: aPeriod,
                value: JOURNAL_DATE_FILTERS[aPeriod],
            })),
            defaultOption: {
                key: 'LAST_7_DAYS',
                value: 'Past 7 Days',
            },
            grid: 3,
        },
    ];
    return filters;
};
